export default __webpack_public_path__ + "static/media/js-badge.485aafc1.svg";